import { Injectable } from '@angular/core';
import { UserApiService } from '../user-repository/user-api.service';

@Injectable({
  providedIn: 'root',
})
export class CheckMetrixService {
  private interval;
  constructor(private UserApiService: UserApiService) {}
  checkMetrix() {
    const metrixUserId = localStorage.getItem('METRIX_CHART_CLIENT_ID')
      ? localStorage.getItem('METRIX_CHART_CLIENT_ID')
      : null;
    const metrixSessionId = localStorage.getItem('METRIX_SESSION_ID')
      ? localStorage.getItem('METRIX_SESSION_ID')
      : null;
    const checkMetrix = localStorage.getItem('checkMetrix')
      ? localStorage.getItem('checkMetrix')
      : null;

    if (
      !metrixSessionId ||
      !metrixUserId ||
      metrixUserId == '' ||
      metrixSessionId == '' ||
      checkMetrix
    ) {
      if (!checkMetrix) {
        localStorage.setItem('checkMetrix', 'true');
      }
      console.log('need to check user metrix');

      this.interval = setInterval(() => {
        this.check();
      }, 600000);
    } else {
      console.log('no need to check user metrix');
    }
  }
  check() {
    console.log('check user metrix');
    const metrixUserId = localStorage.getItem('METRIX_CHART_CLIENT_ID')
      ? localStorage.getItem('METRIX_CHART_CLIENT_ID')
      : null;
    const metrixSessionId = localStorage.getItem('METRIX_SESSION_ID')
      ? localStorage.getItem('METRIX_SESSION_ID')
      : null;
    if (metrixSessionId && metrixUserId) {
      this.updateUser({ metrixSessionId, metrixUserId });
    }
  }
  updateUser({
    metrixUserId,
    metrixSessionId,
  }: {
    metrixUserId: string;
    metrixSessionId: string;
  }) {
    console.log('user metrix founded');

    this.UserApiService.editUser(
      null,
      null,
      null,
      null,
      null,
      metrixUserId,
      metrixSessionId
    );
    localStorage.removeItem('checkMetrix');
    clearInterval(this.interval);
  }
}
